export enum StatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  BY_APPROVE = 'BY_APPROVE',
  APPROVE = 'APPROVE',
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING',
  BANNED = 'BANNED',
  PENDING_ACTIVATION = 'PENDING_ACTIVATION',
  FAVOURITE = 'FAVOURITE',
  ALL = 'ALL',
  ENTRY = 'ENTRY',
  ERROR = 'ERROR',
  EXPIRED = 'EXPIRED',
  FINALIZED = 'FINALIZED',
  DELETED = 'DELETED',
  PAID = 'PAID',
  PENDING_DEBIT = 'PENDING_DEBIT',
  PROCESS = 'PROCESS',
  VOIDED = 'VOIDED',
  EXECUTED = 'EXECUTED',
  EXCEPTION = 'EXCEPTION',
  INACTIVE_IN_PROCESS = 'INACTIVE_IN_PROCESS',
  CONDONED = 'CONDONED',
  ACTIVE_WITH_BENEFITS = 'ACTIVE_WITH_BENEFITS',
  INACTIVE_WITHOUT_BENEFITS = 'INACTIVE_WITHOUT_BENEFITS',
  TIED = 'TIED',
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
}

export enum StatusFinishedEnum {
  NOT_FINISHED = 'NOT_FINISHED',
  FINISHED_INCOMPLETE = 'FINISHED_INCOMPLETE',
  FINISHED_COMPLETE = 'FINISHED_COMPLETE',
}

export enum GenderEnum {
  M = 'M',
  F = 'F',
}

export enum QuestionEnum {
  YES = 'YES',
  NO = 'NO',
}

export enum SectionRequiredEnum {
  HEADERS = 'HEADERS',
  FILTERS = 'FILTERS',
  NO = 'NO',
}

export enum EntryEnum {
  ENABLE = 'ENABLE',
  DISABLE = 'DISABLE',
}

export enum ControlTypeEnum {
  INPUT_TEXT = 'INPUT_TEXT',
  INPUT_TEXT_LARGE = 'INPUT_TEXT_LARGE',
  INPUT_TEXTAREA = 'INPUT_TEXTAREA',
  OPTIONS_LIST = 'OPTIONS_LIST',
  MULTIPLE_OPTIONS_LIST = 'MULTIPLE_OPTIONS_LIST',
  DATE = 'DATE',
  COLOR = 'COLOR',
  FILE = 'FILE',
  FORM_REQUEST = 'FORM_REQUEST',
  QR_READER = 'QR_READER',
  APPROBATION = 'APPROBATION',
  BATCH = 'BATCH',
}

export enum ControlTypeOptionsEnum {
  SERVICES = 'SERVICES',
  PROGRAMMED = 'PROGRAMMED',
  OPTIONS_LIST = 'OPTIONS_LIST',
  OPTIONS_LIST_FILTERED = 'OPTIONS_LIST_FILTERED',
}

export enum FormRequestDetailEnum {
  NO = 'NO',
  DE_UNA = 'DE_UNA',
  MATERIALS = 'MATERIALS',
  UPDATE_ENTITY_AND_LOCATION = 'UPDATE_ENTITY_AND_LOCATION',
  DE_UNA_VERIFICATION_OFFLINE = 'DE_UNA_VERIFICATION_OFFLINE',
  SALES = 'SALES',
  CENTRO_HUB = 'CENTRO_HUB',
}

export enum CharactersEnum {
  ALL = 'ALL',
  INT = 'INT',
  DECIMAL = 'DECIMAL',
  ONLY_LETTERS = 'ONLY_LETTERS',
  LETTERS_AND_NUMBERS = 'LETTERS_AND_NUMBERS',
  PERCENTAGE = 'PERCENTAGE',
  DOLLAR = 'DOLLAR',
  REGULAR_EXPRESSION = 'REGULAR_EXPRESSION',
}

export enum AlignEnum {
  CENTER = 'center',
  LEFT = 'left',
  RIGHT = 'right',
  JUSTIFY = 'justify',
  CHAR = 'char',
}

export enum FormatFunctionEnum {
  DNI = 'DNI',
  RUC = 'RUC',
  DNI_RUC = 'DNI_RUC',
  PHONE = 'PHONE',
  CELLPHONE = 'CELLPHONE',
  REGULAR_EXPRESSION = 'REGULAR_EXPRESSION',
  EMAIL = 'EMAIL',
}

export enum FieldFormEnum {
  REQUIRED = 'REQUIRED',
  OPTIONAL = 'OPTIONAL',
  NO = 'NO',
}

export enum ConvertTextEnum {
  UPPERCASE = 'UPPERCASE',
  LOWERCASE = 'LOWERCASE',
  CAPITALIZE = 'CAPITALIZE',
  ENCRYPTED = 'ENCRYPTED',
  MASKED = 'MASKED',
  NO = 'NO',
}

export enum TypeNotificationEnum {
  MESSAGE = 'MESSAGE',
  VERSION = 'VERSION',
  DOWNLOAD = 'DOWNLOAD',
}

export enum PushNotificationEnum {
  NO = 'NO',
  TO_SEND = 'TO SEND',
  SENT = 'SENT',
}

export enum NotificationTypeEnum {
  MESSAGE = 'MESSAGE',
  VERSION = 'VERSION',
  DOWNLOAD = 'DOWNLOAD',
}

export enum HolidayTypeEnum {
  USER = 'USER',
  NATIONAL = 'NATIONAL',
}

export enum FileTypeEnum {
  NO = 'NO',
  PDF = 'PDF',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  AUDIO = 'AUDIO',
}

export enum PeriodsChartEnum {
  CURRENT_MONTH = 'CURRENT_MONTH',
  CURRENT_MONTH_TODAY = 'CURRENT_MONTH_TODAY',
  CURRENT_MONTH_YESTERDAY = 'CURRENT_MONTH_YESTERDAY',
  NEXT_MONTH = 'NEXT_MONTH',
  LAST_MONTH = 'LAST_MONTH',
  CURRENT_YEAR = 'CURRENT_YEAR',
  LAST_YEAR = 'LAST_YEAR',
  LAST_15_DAYS = 'LAST_15_DAYS',
  RANGE = 'RANGE',
  TODAY = 'TODAY',
  WEEK = 'WEEK',
  YESTERDAY = 'YESTERDAY',
  LAST_WEEK = 'LAST_WEEK',
}

export enum TypeAuthorizationEnum {
  AUTOMATIC = 'AUTOMATIC',
  ASSIGNED = 'ASSIGNED',
}

export enum MeasurementTypeEnum {
  STATUS = 'STATUS',
  ACHIEVED_VALUE = 'ACHIEVED_VALUE',
}
export enum CreationByEnum {
  ALL_USERS = 'ALL_USERS',
  TEAMS = 'TEAMS',
  ASSIGNED_BASE = 'ASSIGNED_BASE',
  PORTFOLIO = 'PORTFOLIO',
}
export enum CreationValidationEnum {
  NO = 'NO',
  UNIQUE_CLIENT = 'UNIQUE_CLIENT',
  NOT_FINISHED = 'NOT_FINISHED',
  NOT_FINISHED_SAME_USER = 'NOT_FINISHED_SAME_USER',
  UNIQUE_USER = 'UNIQUE_USER',
}

export enum UniqueCreationEnum {
  NO = 'NO',
  YES = 'YES',
  ONLY_ENTITIES_TYPE = 'ONLY_ENTITIES_TYPE',
  ALL_ENTITIES = 'ALL_ENTITIES',
}

export enum TableReferenceEnum {
  ENTITIES = 'ENTITIES',
  ENTITIES_DYNAMIC = 'ENTITIES_DYNAMIC',
}

export enum RequiredEnum {
  NO = 'NO',
  REQUIRED = 'REQUIRED',
  NOT_REQUIRED = 'NOT_REQUIRED',
}

export enum FileControlTypeEnum {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  AUDIO = 'AUDIO',
}

export enum AutomaticReportsEnum {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
}

export enum ShowReportsEnum {
  DAILY = 'DAILY',
  DASHBOARD = 'DASHBOARD',
  TRACKING_REALTIME = 'TRACKING_REALTIME',
}
export enum ShowInEnum {
  INITIAL = 'INITIAL',
  FINAL = 'FINAL',
  OFFICE = 'OFFICE',
  COMMERCE = 'COMMERCE',
}
export enum FormPayReferenceEnum {
  EFECTIVE = 'EFECTIVE',
  RES_COBRANZAS = 'RES_COBRANZAS',
  CREDIT_CARD = 'CREDIT_CARD',
  TRANSFER = 'TRANSFER',
  PAYROLL_DEBIT = 'PAYROLL_DEBIT',
  BANK_DEBIT = 'BANK_DEBIT',
}

export enum TypeEnum {
  PORTFOLIO = 'PORTFOLIO',
  NEGOTIATIONS = 'NEGOTIATIONS',
  MEMBERSHIP_PAYMENT = 'MEMBERSHIP_PAYMENT',
  MEMBERSHIP_REGISTRATION = 'MEMBERSHIP_REGISTRATION',
  MEMBERSHIP_ACTIVATE_PAY_PENDING = 'MEMBERSHIP_ACTIVATE_PAY_PENDING',
  MEMBERSHIP_ACTIVATE_NEW_HISTORY = 'MEMBERSHIP_ACTIVATE_NEW_HISTORY',
  MEMBERSHIP_ACTIVATE_FORGIVE_PENDING = 'MEMBERSHIP_ACTIVATE_FORGIVE_PENDING',
  MEMBERSHIP_UPDATE = 'MEMBERSHIP_UPDATE',
  INDIVIDUAL = 'INDIVIDUAL',
  MASSIVE = 'MASSIVE',
  ALL_APPROVED = 'ALL_APPROVED',
  ONE_NOT_APPROVED = 'ONE_NOT_APPROVED',
  ANY_APPROVED = 'ANY_APPROVED',
  ALL_DONE = 'ALL_DONE',
}

export enum BatchStageEnum {
  UPLOAD_FILE = 'UPLOAD_FILE',
  ENTITIES_TYPES_VALIDATION = 'ENTITIES_TYPES_VALIDATION',
  HEADERS_LINK = 'HEADERS_LINK',
  INFORMATION_LINK = 'INFORMATION_LINK',
  ADDRESS_VALIDATION = 'ADDRESS_VALIDATION',
  NEGOTIATIONS_VALIDATION = 'NEGOTIATIONS_VALIDATION',
  DISTRIBUTION_FILTER = 'DISTRIBUTION_FILTER',
  DISTRIBUTION_USERS = 'DISTRIBUTION_USERS',
  EXECUTED = 'EXECUTED',
}

export enum PortfolioUpdateModeEnum {
  UPDATE_USERS = 'UPDATE_USERS',
  UPDATE_USERS_REMOVE_OTHERS = 'UPDATE_USERS_REMOVE_OTHERS',
}

export enum DocumentTypeEnum {
  CEDULA = 'CEDULA',
  RUC = 'RUC',
  PASAPORTE = 'PASAPORTE',
}

export enum TypeItemEnum {
  INTEGER = 'INTEGER',
  STRING = 'STRING',
  CURRENCY = 'CURRENCY',
  PERCENTAGE = 'PERCENTAGE',
  ARRAY_OBJECTS = 'ARRAY_OBJECTS',
  OBJECT = 'OBJECT',
  ICON = 'ICON',
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
  CALCULATION = 'CALCULATION',
}

export enum TypeBatchesExceptionsEnum {
  ROW = 'ROW',
  COLUMN = 'COLUMN',
}
export enum TypeChartEnum {
  PIE = 'PIE',
  COLUMN = 'COLUMN',
  TABLE = 'TABLE',
}

export enum PrintModEnum {
  VERTICAL = 'VERTICAL',
  HORIZONTAL = 'HORIZONTAL',
}

export enum PrintTotalsEnum {
  VERTICAL = 'VERTICAL',
  HORIZONTAL = 'HORIZONTAL',
}

export enum PrintTypeEnum {
  USER_LIST = 'USER_LIST',
  STRUCTURE_GROUPS = 'STRUCTURE_GROUPS',
}

export enum CollapseDefaultEnum {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
}

export enum EventTypeEnum {
  INTERACTION = 'INTERACTION',
  EVENT = 'EVENT',
  CALENDAR = 'CALENDAR',
  NEGOTIATION = 'NEGOTIATION',
}

export enum ReminderTypeEnum {
  EMAIL = 'EMAIL',
  NOTIFICATION = 'NOTIFICATION',
  ALL = 'ALL',
}

export enum NoveltyEnum {
  NO = 'NO',
  ENTITY = 'ENTITY',
  LOCATION = 'LOCATION',
}

export enum GeoreferenceTypeEnum {
  CONFIRMATED = 'CONFIRMATED',
  REFERENCE = 'REFERENCE',
  NO_LOCATION = 'NO_LOCATION',
}

export enum EntityListTypes {
  ALL = 'ALL',
  MY_ENTITIES = 'MY_ENTITIES',
  NEW_LAST_WEEK = 'NEW_LAST_WEEK',
  NEW_CURRENT_WEEK = 'NEW_CURRENT_WEEK',
  PRIORITY = 'PRIORITY',
}

export enum ActivityTypeEnum {
  PHOTOGRAPH = 'PHOTOGRAPH',
  SURVEY = 'SURVEY',
  MATERIAL = 'MATERIAL',
  EDIT_ENTITY = 'EDIT_ENTITY',
  INDICATORS = 'INDICATORS',
  EDIT_LOCATION = 'EDIT_LOCATION',
  PHOTOGRAPH_FACADE = 'PHOTOGRAPH_FACADE',
  COMMENTARY = 'COMMENTARY',
  MOBILIZATION_VALUE = 'MOBILIZATION_VALUE',
  CALENDAR = 'CALENDAR',
  NEGOTIATIONS = 'NEGOTIATIONS',
  CREATE_ENTITY_LOCATION = 'CREATE_ENTITY_LOCATION',
  SALES = 'SALES',
  CONTACT_INFORMATION = 'CONTACT_INFORMATION',
  CONTACTS = 'CONTACTS',
  USER_ACCOMPANIMENT = 'USER_ACCOMPANIMENT',
  ENTITIES_LOCATION = 'ENTITIES_LOCATION',
}

export enum NegotiationsTagsTypeEnum {
  NEGOTIATION_TYPE = 'NEGOTIATION_TYPE',
  NEGOTIATION = 'NEGOTIATION',
}

export enum EntityListTypeEnum {
  ALL = 'ALL',
  MY_PORTFOLIO = 'MY_PORTFOLIO',
  NEWS_LAST_WEEK = 'NEWS_LAST_WEEK',
  NEWS_CURRENT_WEEK = 'NEWS_CURRENT_WEEK',
  PRIORITY = 'PRIORITY',
  MY_ASSIGNS = 'MY_ASSIGNS',
  MY_ASSIGNS_FINISHED = 'MY_ASSIGNS_FINISHED',
  MY_ASSIGNS_ACTIVE = 'MY_ASSIGNS_ACTIVE',
  UNPLANNED = 'UNPLANNED',
  NEGOTIATIONS = 'NEGOTIATIONS',
  MY_CREATIONS = 'MY_CREATIONS',
  MY_BACKUPS = 'MY_BACKUPS',
}

export enum AssignmentTypeEnum {
  OWN = 'OWN',
  ASSIGNED_BASE = 'ASSIGNED_BASE',
  RE_ASSIGNED = 'RE_ASSIGNED',
}

export enum SourceEnum {
  APP = 'APP',
  WEB = 'WEB',
  MIGRATION = 'MIGRATION',
}

export enum SourceTableEnum {
  TABLE = 'TABLE',
  PIVOT = 'PIVOT',
}

export enum TemporaryStateEnum {
  FINALIZED = 'FINALIZED',
  PROCESS = 'PROCESS',
  CANCELLED = 'CANCELLED',
}

export enum TimestampTypeEnum {
  YESTERDAY = 'YESTERDAY',
  TOMORROW = 'TOMORROW',
  TODAY = 'TODAY',
  TIMED_OUT = 'TIME_OUT',
  ON_TIME = 'ON_TIME',
}

export enum DayFilterEnum {
  ALL = 'ALL',
  TODAY = 'TODAY',
  YESTERDAY = 'YESTERDAY',
  THIS_WEEK = 'THIS_WEEK',
  TODAY_BACKWARDS = 'TODAY_BACKWARDS',
  TODAY_FORWARD = 'TODAY_FORWARD',
}

export enum ShowBatcheExceptionEnum {
  INDIVIDUAL = 'INDIVIDUAL',
  MASSIVE = 'MASSIVE',
}

export enum TableNameEnum {
  TASKS_CATEGORIES = 'TASKS_CATEGORIES',
  USERS = 'USERS',
  NEGOTIATIONS_TYPES = 'NEGOTIATIONS_TYPES',
  NEGOTIATIONS_TAGS = 'NEGOTIATIONS_TAGS',
  NEGOTIATIONS_TYPES_TAGS = 'NEGOTIATIONS_TYPES_TAGS',
  NEGOTIATIONS_TAGS_CATEGORIES = 'NEGOTIATIONS_TAGS_CATEGORIES',
  NEGOTIATIONS_TYPES_TAGS_CATEGORIES = 'NEGOTIATIONS_TYPES_TAGS_CATEGORIES',
  INTERACTIONS_TYPES = 'INTERACTIONS_TYPES',
  INTERACTIONS_TYPES_STATUSES = 'INTERACTIONS_TYPES_STATUSES',
  ENTITIES_LOCATIONS = 'ENTITIES_LOCATIONS',
  CONTACTS = 'CONTACTS',
  USERS_ACCOMPANIMENTS = 'USERS_ACCOMPANIMENTS',
  TASKS = 'TASKS',
  EVENTS = 'EVENTS',
  NEGOTIATIONS_HISTORIES_STATUSES = 'NEGOTIATIONS_HISTORIES_STATUSES',
  NEGOTIATIONS_TYPES_STATUSES = 'NEGOTIATIONS_TYPES_STATUSES',
  NEGOTIATIONS_TYPES_MACROSTATUSES = 'NEGOTIATIONS_TYPES_MACROSTATUSES',
  INTERACTIONS = 'INTERACTIONS',
  TEAM_FUNCTION = 'TEAM_FUNCTION',
  SPECIFIC_USERS = 'SPECIFIC_USERS',
  OWNER_USER = 'OWNER_USER',
  NEGOTIATIONS = 'NEGOTIATIONS',
  TEAMS = 'TEAMS',
  ENTITIES_ITINERARIES = 'ENTITIES_ITINERARIES',
  SECTIONS = 'SECTIONS',
  API_CONECTIONS = 'API_CONECTIONS',
  BATCHES = 'BATCHES',
  ENTITIES_TYPES = 'ENTITIES_TYPES',
  ENTITIES_TYPES_FIELDS = 'ENTITIES_TYPES_FIELDS',
  FILTERS = 'FILTERS',
  ITINERARIES = 'ITINERARIES',
  ENTITIES_LOCATIONS_TYPES = 'ENTITIES_LOCATIONS_TYPES',
  ENTITIES = 'ENTITIES',
  HOLIDAYS = 'HOLIDAYS',
  UNPRODUCTIVES = 'UNPRODUCTIVES',
  COLORS = 'COLORS',
  ICONS = 'ICONS',
  LEVELSTEAMS = 'LEVELSTEAMS',
  GROUPSCATEGORIES = 'GROUPSCATEGORIES',
  GROUPS = 'GROUPS',
  GROUPSRULES = 'GROUPSRULES',
  PROFILES = 'PROFILES',
  TUTORIALS = 'TUTORIALS',
  LICENSES = 'LICENSES',
  WIDGETS = 'WIDGETS',
  WIDGETSSECTIONSCOLUMN = 'WIDGETSSECTIONSCOLUMN',
  VIEWERS = 'VIEWERS',
  VIEWERS_KPIS = 'VIEWERS_kPIS',
  VIEWERS_SECTIONS = 'VIEWERS_SECTIONS',
  VIEWERS_BUDGETS = 'VIEWERS_BUDGETS',
  BUDGETS = 'BUDGETS',
  LOG_CREATION = 'LOG_CREATION',
  LOG_EDITION = 'LOG_EDITION',
  LOG_ELIMINATION = 'LOG_ELIMINATION',
  LOG_LOGIN = 'LOG_LOGIN',
  LOG_NAVIGATION = 'LOG_NAVIGATION',
  LOG_USABILITY = 'LOG_USABILITY',
  ACTIVITIES = 'ACTIVITIES',
  INITIAL_ACTIVITIES = 'INITIAL_ACTIVITIES',
  FINAL_ACTIVITIES = 'FINAL_ACTIVITIES',
  CUSTOMER_NEGOTIATIONS = 'CUSTOMER_NEGOTIATIONS',
  SECTORIZATIONS = 'SECTORIZATIONS',
  MATERIALS = 'MATERIALS',
  MATERIALS_COUNT = 'MATERIALS_COUNT',
  REQUISITIONS = 'REQUISITIONS',
  MATERIALS_NEGOTIATIONS_HISTORIES_STATUSES = 'MATERIALS_NEGOTIATIONS_HISTORIES_STATUSES',
  CITIES = 'CITIES',
  PARISHES = 'PARISHES',
  RECEPTIONS = 'RECEPTIONS',
  RECEPTIONS_STATUSES = 'RECEPTIONS_STATUSES',
  ADDITIONALS_INFORMATIONS = 'ADDITIONALS_INFORMATIONS',
  FIELDS = 'FIELDS',
  SECTORS = 'SECTORS',
  PROVINCES = 'PROVINCES',
  CANTONS = 'CANTONS',
  MONITORS = 'MONITORS',
  MONITORS_SECTORS = 'MONITORS_SECTORS',
  DISTRIBUTIONS_SECTORS = 'DISTRIBUTIONS_SECTORS',
  UTILITIES = 'UTILITIES',
  NEGOTIATIONS_TYPES_NEGOTIATIONS = 'NEGOTIATIONS_TYPES_NEGOTIATIONS',
  VIEWERS_PERIODS_MACROCATEGORIES = 'VIEWERS_PERIODS_MACROCATEGORIES',
  VIEWERS_PERIODS_CATEGORIES = 'VIEWERS_PERIODS_CATEGORIES',
  VIEWERS_PERIODS_MICROCATEGORIES = 'VIEWERS_PERIODS_MICROCATEGORIES',
  MONITORS_SECTORS_ALERTS_TYPES = 'MONITORS_SECTORS_ALERTS_TYPES',
  MONITORS_SECTORS_JUSTIFICATIONS_TYPES = 'MONITORS_SECTORS_JUSTIFICATIONS_TYPES',
  VALIDATIONS_COMMISSIONS_PERIODS = 'VALIDATIONS_COMMISSIONS_PERIODS',
  ITEMS_CATEGORIES = 'ITEMS_CATEGORIES',
  ITEMS = 'ITEMS',
  CONTACTS_TYPES = 'CONTACTS_TYPES',
  BRANCHES = 'BRANCHES',
  BRIEFS_TYPES = 'BRIEFS_TYPES',
  BRIEFS_TYPES_STATUSES = 'BRIEFS_TYPES_STATUSES',
  BRIEFS_TYPES_MACROSTATUSES = 'BRIEFS_TYPES_MACROSTATUSES',

  USERS_RELATIONSHIPS_TYPES = 'USERS_RELATIONSHIPS_TYPES',
  NEGOTIATIONS_TYPES_STATUSES_CATEGORIES = 'NEGOTIATIONS_TYPES_STATUSES_CATEGORIES',
  USERS_RELATIONSHIPS = 'USERS_RELATIONSHIPS',
  PAYMENTS_TYPES = 'PAYMENTS_TYPES',
  PAYMENTS_PERIODS = 'PAYMENTS_PERIODS',
  MEMBERSHIPS_TYPES = 'MEMBERSHIPS_TYPES',
  TICKETS_PRIORITIES = 'TICKETS_PRIORITIES',
  TICKETS_TYPES = 'TICKETS_TYPES',
  ITEMS_PARENTS_CATEGORIES = 'ITEMS_PARENTS_CATEGORIES',
  ITEMS_PARENTS = 'ITEMS_PARENTS',
  ITEMS_SUBCATEGORIES = 'ITEMS_SUBCATEGORIES',
  ITEMS_CLIENTS = 'ITEMS_CLIENTS',
  ITEMS_PARENTS_FEATURES = 'ITEMS_PARENTS_FEATURES',
  UNPRODUCTIVES_TYPES = 'UNPRODUCTIVES_TYPES',
  PAYMENTS_METHODS = 'PAYMENTS_METHODS',
  SCHEDULES_EMAILS_SENT = 'SCHEDULES_EMAILS_SENT',
  EMAILINGS = 'EMAILINGS',
  EMAILING_FIELDS = 'EMAILING_FIELDS',
  EMAILING_IMAGES = 'EMAILING_IMAGES',
  EMAILING_SENDERS = 'EMAILING_SENDERS',
  PROCESSES_TYPES_MACROSTATUSES = 'PROCESSES_TYPES_MACROSTATUSES',
  PROCESSES_CATEGORIES = 'PROCESSES_CATEGORIES',
  PROCESSES_TYPES = 'PROCESSES_TYPES',
  PROCESSES_TYPES_STATUSES = 'PROCESSES_TYPES_STATUSES',
  PROCESSES_TASKS_TYPES = 'PROCESSES_TASKS_TYPES',
  PROCESSES_TASKS_TYPE_PROCESSES_TYPES_STATUS = 'PROCESSES_TASKS_TYPE_PROCESSES_TYPES_STATUS',
  ITINERARIES_SOURCES = 'ITINERARIES_SOURCES',
  USERS_MATCHES_REFERENCES = 'USERS_MATCHES_REFERENCES',
  WHATSAPP_TEMPLATES_FIELDS = 'WHATSAPP_TEMPLATES_FIELDS',
  PLANS = 'PLANS',
}

export enum EmptySelectOption {
  NO_CONTACT = 'NO_CONTACT',
  NO_USER_ACCOMPANIMENT = 'NO_USER_ACCOMPANIMENT',
  NO_ENTITIES_LOCATION = 'NO_ENTITIES_LOCATION',
  NO_ITINERARY = 'NO_ITINERARY',
}

export enum CalculationEnum {
  NO = 'NO',
  SUM = 'SUM',
  AVG = 'AVG',
}

export enum DoneEnum {
  YES = 'YES',
  NO = 'NO',
  ALL = 'ALL',
}

export enum InvitationStatusEnum {
  CONFIRMED = 'CONFIRMED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}

export enum RoleEnum {
  CREATOR = 'CREATOR',
  GUEST = 'GUEST',
}

export enum SynchronizedEnum {
  NO = 'NO',
  OUTLOOK = 'OUTLOOK',
  GOOGLE = 'GOOGLE',
}

export enum FilterDateActivities {
  ALL = 'ALL',
  UPCOMING_OVERDUE = 'UPCOMING_OVERDUE',
  YESTERDEY = 'YESTERDAY',
  TODAY = 'TODAY',
  LAST_7_DAYS = 'LAST_7_DAYS',
}

export enum FilterDateEvents {
  CURRENT_MONTH_TODAY = 'CURRENT_MONTH_TODAY',
  CURRENT_MONTH_YESTERDAY = 'CURRENT_MONTH_YESTERDAY',
  PREVIOUS_MONTH = 'PREVIOUS_MONTH',
  DATE_RANGE = 'DATE_RANGE',
}

export enum ParticipantTypeEvent {
  MY_EVENTS = 'MY_EVENTS',
  GUESTS = 'GUESTS',
}

export enum NegotiationFilterEnum {
  ALL = 'ALL',
  ACTIVE = 'ACTIVE',
  HISTORICAL = 'HISTORICAL',
  MINE = 'MINE',
  OTHER = 'OTHER',
  FINISHED = 'FINISHED',
  UNFINISHED = 'UNFINISHED',
  ATTENDANT = 'ATTENDANT',
}

export enum RelatedNegotiationFilterEnum {
  ALL = 'ALL',
  INTERACTION = 'INTERACTION',
}

export enum InteractionFilterEnum {
  ALL = 'ALL',
  MINE = 'MINE',
  FINISHED = 'FINISHED',
  ENTRY = 'ENTRY',
  ENTRY_MANAGEMENT = 'ENTRY_MANAGEMENT',
}

export enum DateFilterEnum {
  TODAY = 'TODAY',
  YESTERDAY = 'YESTERDAY',
  LAST_WEEK = 'LAST_WEEK',
  CURRENT_WEEK = 'CURRENT_WEEK',
  NEXT_WEEK = 'NEXT_WEEK',
  CURRENT_YEAR = 'CURRENT_YEAR',
  CURRENT_YEAR_TODAY = 'CURRENT_YEAR_TODAY',
  CURRENT_YEAR_YESTERDAY = 'CURRENT_YEAR_YESTERDAY',
  LAST_YEAR = 'LAST_YEAR',
  CURRENT_MONTH_TODAY = 'CURRENT_MONTH_TODAY',
  CURRENT_MONTH_YESTERDAY = 'CURRENT_MONTH_YESTERDAY',
  TODAY_END_CURRENT_MONTH = 'TODAY_END_CURRENT_MONTH',
  LAST_MONTH = 'LAST_MONTH',
  CURRENT_MONTH = 'CURRENT_MONTH',
  NEXT_MONTH = 'NEXT_MONTH',
  DATE_RANGE = 'DATE_RANGE',
  DATE_SELECT = 'DATE_SELECT',
  ALL = 'ALL',

  CURRENT_WEEK_TODAY = 'CURRENT_WEEK_TODAY',
  LAST_WEEK_TODAY = 'LAST_WEEK_TODAY',
  LAST_YEAR_TODAY = 'LAST_YEAR_TODAY',
  LAST_MONTH_TODAY = 'LAST_MONTH_TODAY',
}

export enum TypeCheckEnum {
  ALL = 'ALL',
  ITEM = 'ITEM',
}

export enum DayTypeEnum {
  WEEK = 'WEEK',
  WEEKEND = 'WEEKEND',
  WORKING = 'WORKING',
}

export enum TransferUserEnum {
  NO = 'NO',
  TEAM_FUNCTION = 'TEAM_FUNCTION',
  SPECIFIC_USERS = 'SPECIFIC_USERS',
  OWNER_USER = 'OWNER_USER',
  RULES = 'RULES',
  GROUPS = 'GROUPS',
  GROUPS_CATEGORIES = 'GROUPS_CATEGORIES',
  USERS_RELATIONSHIPS_OWNER = 'USERS_RELATIONSHIPS_OWNER',
  USERS_RELATIONSHIPS_ATTENDANT = 'USERS_RELATIONSHIPS_ATTENDANT',
}

export enum CreationUserEnum {
  USER_OWNER = 'USER_OWNER',
  USER_EDIT = 'USER_EDIT',
  TEAM_MANAGEMENT_USERS = 'TEAM_MANAGEMENT_USERS',
  MANAGEMENT_USERS = 'MANAGEMENT_USERS',
  ALL = 'ALL',
  BY_ASSIGNING = 'BY_ASSIGNING',
}

export enum TableTypeBatchEnum {
  DYNAMIC_HORIZONTAL_TABLE = 'DYNAMIC_HORIZONTAL_TABLE',
  DYNAMIC_VERTICAL_TABLE = 'DYNAMIC_VERTICAL_TABLE',
  AGENCY_COMPARISON_TABLE = 'AGENCY_COMPARISON_TABLE',
}

export enum CodeTypeValidation {
  LOGIN = 'LOGIN',
  REGISTER = 'REGISTER',
  PASSWORD_CHANGE = 'PASSWORD_CHANGE',
  PASSWORD_RECOVERY = 'PASSWORD_RECOVERY',
}

export enum ReportTypeEnum {
  DOWNLOAD = 'DOWNLOAD',
  VISUALIZE = 'VISUALIZE',
}

export enum ItineraryTypeEnum {
  PLANNED = 'PLANNED',
  SWEPT = 'SWEPT',
}
export enum IBudgetTypeEnum {
  COUNT_NEGOTIATIONS = 'COUNT_NEGOTIATIONS',
  SUM_ADDITIONALS_INFORMATIONS = 'SUM_ADDITIONALS_INFORMATIONS',
}
export enum IValueTypeEnum {
  INTEGER = 'INTEGER',
  DECIMAL = 'DECIMAL',
  DOLLAR = 'DOLLAR',
}

export enum ChartTypeOptionsEnum {
  COLUMN_LINE = 'COLUMN_LINE',
  DOUBLE_COLUMN = 'DOUBLE_COLUMN',
}

export enum StatusAuthenticationsEnum {
  SATISFACTORY = 'SATISFACTORY',
  NOT_AUTHENTICATED = 'NOT_AUTHENTICATED',
  NOT_FOUND = 'NOT_FOUND',
}

export enum TypeAuthenticationEnum {
  BASIC = 'BASIC',
  TOKEN = 'TOKEN',
  API = 'API',
  FREE = 'FREE',
  OAUTH2 = 'OAUTH2.0',
  API_KEY = 'API_KEY',
}

export enum MethodEnum {
  POST = 'POST',
  GET = 'GET',
  PUT = 'PUT',
  DELETED = 'DELETED',
}
export enum CertificateTypeEnum {
  PFX = 'PFX',
  PEM = 'PEM',
}

export enum TotalConfigurationEnum {
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL',
  NO = 'NO',
}

export enum CalculationTypeEnum {
  YEARS_OLD = 'YEARS_OLD',
  TERM_EXPIRES = 'TERM_EXPIRES',
  PERCENTAGE = 'PERCENTAGE',
  CURRENCY = 'CURRENCY',
  ICON_CHECK_CONDITIONAL = 'ICON_CHECK_CONDITIONAL',
}

export enum FieldTypeEnum {
  ENTITY = 'ENTITY',
  NEGOTIATIONS_TYPE = 'NEGOTIATIONS_TYPE',
}

export enum FieldSystempeEnum {
  PHOTOGRAPHY_USERS = 'PHOTOGRAPHY_USERS',
  COVER_PHOTO_USERS = 'COVER_PHOTO_USERS',
}

export enum DisplayEnum {
  ALL = 'ALL',
  SYSTEM = 'SYSTEM',
  GENERAL = 'GENERAL',
  USER = 'USER',
}

export enum ShowDataReportEnum {
  PLANNING = 'PLANNING',
  EVENTS = 'EVENTS',
  LOG_CREATION = 'LOG_CREATION',
  LOG_EDITION = 'LOG_EDITION',
  LOG_ELIMINATION = 'LOG_ELIMINATION',
  LOG_LOGIN = 'LOG_LOGIN',
  LOG_NAVIGATION = 'LOG_NAVIGATION',
}

export enum SetInEnum {
  CREATE = 'CREATE',
  BATCHES = 'BATCHES',
  UPDATE_ALL_STATUS = 'UPDATE_ALL_STATUS',
  UPDATE_NO_FINALIZED = 'UPDATE_NO_FINALIZED',
  CARD_NO_FINALIZED = 'CARD_NO_FINALIZED',
  CARD_ALL_STATUS = 'CARD_ALL_STATUS',
}

export enum TypeQuestionEnum {
  MANUAL_QUESTION = 'MANUAL_QUESTION',
  OTHER_QUESTION = 'OTHER_QUESTION',
  IMAGE = 'IMAGE',
}

export enum TypeFilterNegotiationsEnum {
  NO_MANAGEMENT = 'NO_MANAGEMENT',
  NOTIFICATIONS_MANAGED = 'NOTIFICATIONS_MANAGED',
  NEGOTIATIONS_FINISHED = 'NEGOTIATIONS_FINISHED',
  NEGOTIATIONS_NOT_FINISHED = 'NEGOTIATIONS_NOT_FINISHED',
  SAME_USER = 'SAME_USER',
  DIFFERENT_USER = 'DIFFERENT_USER',
  PROFILES = 'PROFILES',
  NOT_PROFILES = 'NOT_PROFILES',
}

export enum typeMeasurementEnum {
  COUNT_NEGOTIATIONS = 'COUNT_NEGOTIATIONS',
  COUNT_INTERACTIONS = 'COUNT_INTERACTIONS',
  COUNT_ENTITIES = 'COUNT_ENTITIES',
  CALCULATION = 'CALCULATION',
  SUM_NEGOTIATIONS_ADDITIONALS_INFORMATIONS = 'SUM_NEGOTIATIONS_ADDITIONALS_INFORMATIONS',
  SUM_HISTORIES_NEGOTIATIONS_ADDITIONALS_INFORMATIONS = 'SUM_HISTORIES_NEGOTIATIONS_ADDITIONALS_INFORMATIONS',
  COUNT_EVENTS = 'COUNT_EVENTS',
  COUNT_ENTITIES_ITINERARIES = 'COUNT_ENTITIES_ITINERARIES',
  BUDGETS = 'BUDGETS',
  CONDITIONALS = 'CONDITIONALS',
  EXTERNAL_DATA = 'EXTERNAL_DATA',
  GOAL_EXTERNAL_DATA = 'GOAL_EXTERNAL_DATA',
}

export enum listUserEnum {
  GROUPS_CATEGORIES = 'GROUPS_CATEGORIES',
  LIST_USERS = 'LIST_USERS',
}

export enum budgetsPeriodsEnum {
  NO = 'NO',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
}

export enum NegotiationTypeSettingTypesEnum {
  ALLOCATED_AMOUNT = 'ALLOCATED_AMOUNT',
  AMOUNT_REACHED = 'AMOUNT_REACHED',
  POSITIVE = 'POSITIVE',
}

export enum NegotiationTypeSettingRelationsEnum {
  ADDITIONALS_INFORMATION = 'additionals_information',
  NEGOTIATIONS_TYPES_STATUS = 'negotiations_types_status',
}

export enum ExecutionStatusEnum {
  IN_SETTINGS = 'IN_SETTINGS',
  PROCESSING = 'PROCESSING',
  PROCESSED = 'PROCESSED',
  ERROR = 'ERROR',
}

export enum MassiveActionEnum {
  REASSIGN = 'REASSIGN',
  DELETE = 'DELETE',
}

export enum ActionValidateNegotiation {
  USE = 'USE',
  CREATE = 'CREATE',
}
export enum ConvertViewEnum {
  PHONE = 'PHONE',
  QR_CODE = 'QR_CODE',
  EMAIL = 'EMAIL',
  MATERIALS = 'MATERIALS',
  ADDRESS = 'ADDRESS',
  IMAGE = 'IMAGE',
  NO = 'NO',
  MOBILE = 'MOBILE',
  WHATSAPP = 'WHATSAPP',
  DOLLAR = 'DOLLAR',
}

export enum EntitiesTypesFieldFormEnum {
  CREATABLE = 'CREATABLE',
  EDITABLE = 'EDITABLE',
}

export enum ActionSelectEnum {
  SELECT = 'SELECT',
  UNSELECT = 'UNSELECT',
}
export enum PrintAdditionalInformationEnum {
  TABLE = 'TABLE',
  DETAIL = 'DETAIL',
}
export enum MaterialSyncStatusEnum {
  PENDING_SYNC = 'PENDING_SYNC',
  SYNCHRONIZED = 'SYNCHRONIZED',
}
export enum RequiredEntitiesLocationEnum {
  REQUIRED = 'REQUIRED',
  NOT_REQUIRED = 'NOT_REQUIRED',
  NO = 'NO',
}
export enum BatchesTypeHeaderLinksEnum {
  FIELDS = 'FIELDS',
  PROGRAMMED = 'PROGRAMMED',
  EXCEPTION = 'EXCEPTION',
  ADDITIONAL_INFORMATION = 'ADDITIONAL_INFORMATION',
  FIELDS_ENTITIES_LOCATIONS = 'FIELDS_ENTITIES_LOCATIONS',
}
export enum SearchFilterTypeEnum {
  MY_PORTFOLIO = 'MY_PORTFOLIO',
  OTHER_PORTFOLIOS = 'OTHER_PORTFOLIOS',
  NEGOTIATIONS = 'NEGOTIATIONS',
}
export enum locationsTypeCheckEnum {
  NEGOTIATIONS = 'NEGOTIATIONS',
  ENTITIES = 'ENTITIES',
}
export enum sectoringModeEnum {
  AUTOMATIC = 'AUTOMATIC',
  MANUAL = 'MANUAL',
  AUTOMATIC_MANUAL = 'AUTOMATIC,MANUAL',
}
export enum StatusMonitorEnum {
  TO_START = 'TO_START',
  IN_PROCESS = 'IN_PROCESS',
  FINALIZED = 'FINALIZED',
}
export enum DistributionTypeEnum {
  RANDOM_EQUITABLE = 'RANDOM_EQUITABLE',
  RANDOM_PREVAILS_PORTFOLIO = 'RANDOM_PREVAILS_PORTFOLIO',
  RANDOM_PREVAILS_AGENCY = 'RANDOM_PREVAILS_AGENCY',
}
export enum DistributionAgencyFilterEnum {
  CITY = 'CITY',
  PARISH = 'PARISH',
  CANTON = 'CANTON',
  PROVINCE = 'PROVINCE',
}

export enum ReferenceEnum {
  ADDITIONALS_INFORMATION = 'ADDITIONALS_INFORMATION',
  FIELDS = 'FIELDS',
}
export enum transferNegotiationsEnum {
  OWNER = 'OWNER',
  ATTENDANT = 'ATTENDANT',
  NO = 'NO',
  OWNER_AND_ATTENDANT = 'OWNER,ATTENDANT',
}
export enum TerritorialTypeEnum {
  PARISH = 'PARISH',
  CANTON = 'CANTON',
  PROVINCE = 'PROVINCE',
}
export enum PropertyEnum {
  MINE = 'MINE',
  OTHER = 'OTHER',
  ALL = 'ALL',
}
export enum LocationsPointsEnum {
  CHANGE_WORKING_STATUS = 'CHANGE_WORKING_STATUS',
  LOCATION = 'LOCATION',
  REQUESTED = 'REQUESTED',
  INTERACTION = 'INTERACTION',
  ERROR = 'ERROR',
}

export enum IncidenceLocationsPointsEnum {
  NO_REGISTRATION = 'NO_REGISTRATION',
  WITHIN_SECTOR = 'WITHIN_SECTOR',
  OUT_SECTOR = 'OUT_SECTOR',
}

export enum ViewersKpisFilterTypeEnum {
  ENTITIES_TYPES = 'ENTITIES_TYPES',
  INTERACTIONS_TYPES = 'INTERACTIONS_TYPES',
  INTERACTIONS_TYPES_STATUSES = 'INTERACTIONS_TYPES_STATUSES',
  INTERACTIONS_ASSOCIATED_NEGOTIATIONS = 'INTERACTIONS_ASSOCIATED_NEGOTIATIONS',
  INTERACTIONS_ASSOCIATED_ITINERARIES = 'INTERACTIONS_ASSOCIATED_ITINERARIES',
  INTERACTIONS_ASSOCIATED = 'INTERACTIONS_ASSOCIATED',
  NEGOTIATIONS_TYPES = 'NEGOTIATIONS_TYPES',
  NEGOTIATIONS_TYPES_STATUSES = 'NEGOTIATIONS_TYPES_STATUSES',
  NEGOTIATIONS_TYPES_STATUSES_HISTORIES = 'NEGOTIATIONS_TYPES_STATUSES_HISTORIES',
  NEGOTIATIONS_TYPES_MACROSTATUSES = 'NEGOTIATIONS_TYPES_MACROSTATUSES',
  ADDITIONALS_INFORMATIONS = 'ADDITIONALS_INFORMATIONS',
  EVENTS_TYPES = 'EVENTS_TYPES',
  IS_DONE = 'IS_DONE',
  IS_FINISHED = 'IS_FINISHED',
  IS_EXPIRED = 'IS_EXPIRED',
  TIME_LIMIT = 'TIME_LIMIT',
  TYPE_STATUS_EXPIRATION = 'TYPE_STATUS_EXPIRATION',
  ADDITIONALS_INFORMATIONS_ASSOCIATED = 'ADDITIONALS_INFORMATIONS_ASSOCIATED',
  ADDITIONALS_INFORMATIONS_SEARCH = 'ADDITIONALS_INFORMATIONS_SEARCH',
  DAYS = 'DAYS',
  HAVE_BATCH = 'HAVE_BATCH',
  BATCHES = 'BATCHES',
  EXTERNAL_DATA_REFERENCE = 'EXTERNAL_DATA_REFERENCE',
  GOAL_FRECUENCY = 'GOAL_FRECUENCY',
  FIRST_OR_LAST = 'FIRST_OR_LAST',
  APPLY_BATCHES = 'APPLY_BATCHES',
}
export enum AssociatedEnum {
  NEGOTIATIONS = 'NEGOTIATIONS',
  ITINERARIES = 'ITINERARIES',
  HISTORIES_NEGOTIATIONS = 'HISTORIES_NEGOTIATIONS',
}

export enum ComparisonEnum {
  GREATER_THAN = 'GREATER_THAN',
  LESS_THAN = 'LESS_THAN',
  GREATER_OR_EQUAL_THAN = 'GREATER_OR_EQUAL_THAN',
  LESS_OR_EQUAL_THAN = 'LESS_OR_EQUAL_THAN',
}
export enum ExpirationEnum {
  IN_TIME = 'IN_TIME',
  OUT_OF_TIME = 'OUT_OF_TIME',
}
export enum FilterDateTypeEnum {
  BY_DAY = 'BY_DAY',
  BY_RANGE = 'BY_RANGE',
}
export enum TableDirectionEnum {
  VERTICAL = 'VERTICAL',
  HORIZONTAL = 'HORIZONTAL',
}
export enum AlertExclusionEnum {
  OUT_OF_SECTOR = 'OUT_OF_SECTOR',
  NO_INTERACTIONS = 'NO_INTERACTIONS',
}
export enum FilterSectorEnum {
  ALL = 'ALL',
  WITHIN = 'WITHIN',
  OUT_OF = 'OUT_OF',
}
export enum FilterTimeEnum {
  ALL = 'ALL',
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
  WITHOUT_CONNECTION = 'WITHOUT_CONNECTION',
}
export enum IntincidenceMonitorsSectorsEnum {
  WITHIN_SECTOR = 'WITHIN_SECTOR',
  OUT_SECTOR = 'OUT_SECTOR',
}
export enum InitialDefaultEnum {
  YES = 'YES',
  NO = 'NO',
}
export enum DistributionExcludeFinalizedEnum {
  YES = 'YES',
  NO = 'NO',
}
export enum CreationTypeEnum {
  UNIQUE = 'UNIQUE',
  UNIQUE_NOT_FINISHED = 'UNIQUE_NOT_FINISHED',
  FREE = 'FREE',
}
export enum ActionTypeEnum {
  CREATION = 'CREATION',
  UPDATE = 'UPDATE',
}
export enum ViewerTypeEnum {
  STANDARD = 'STANDARD',
  CHALLENGE = 'CHALLENGE',
  BUDGET = 'BUDGET',
  MANAGEMENT_PROGRESS = 'MANAGEMENT_PROGRESS',
}
export enum ValidationsCommissionsAprrovedEnum {
  YES = 'YES',
  NO = 'NO',
  TO_BE_APPROVED = 'TO_BE_APPROVED',
  ALL = 'ALL',
}
export enum ApplyCommissionsEnum {
  NO = 'NO',
  AUTOMATIC_VALIDATION = 'AUTOMATIC_VALIDATION',
  MANUAL_VALIDATION = 'MANUAL_VALIDATION',
}
export enum FilterTypeEnum {
  SAME = 'SAME',
  LIST = 'LIST',
}
export enum ActionsProcessEnum {
  START_GROUP = 'START_GROUP',
  END_GROUP = 'END_GROUP',
}
export enum MonitorsSectorStatusEnum {
  ALL = 'ALL',
  CURRENT = 'CURRENT',
  NOT_CURRENT = 'NOT_CURRENT',
}

export enum RequiredContactEnum {
  NO = 'NO',
  REQUIRED = 'REQUIRED',
  NOT_REQUIRED = 'NOT_REQUIRED',
}
export enum TableOptionsEnum {
  SELECTIONS = 'SELECTIONS',
}

export enum GeneralsTableActionsEnum {
  EDIT = 'EDIT',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  ADD = 'ADD',
  GROUP = 'GROUP',
  ENTITIES_TYPES = 'ENTITIES_TYPES',
  AUTHORIZATIONS = 'AUTHORIZATIONS',
  RULES = 'RULES',
  EDIT_PASSWORD = 'EDIT_PASSWORD',
  USERS = 'USERS',
  USERS_RELATIONSHIPS = 'USERS_RELATIONSHIPS',
  PROJECTS = 'PROJECTS',
  TOKENS = 'TOKENS',
  REMOVE_TOKENS = 'REMOVE_TOKENS',
  VIEWERS = 'VIEWERS',
}

export enum EffectiveEnum {
  NO = 'NO',
  YES = 'YES',
}

export enum validityStatusEnum {
  ALL = 'ALL',
  CURRENT = 'CURRENT',
  NOT_CURRENT = 'NOT_CURRENT',
}
export enum TransferUserTargetEnum {
  OWNER = 'OWNER',
  ATTENDANT = 'ATTENDANT',
  OWNER_AND_ATTENDANT = 'OWNER_AND_ATTENDANT',
}
export enum BatchFiltersEnum {
  WITH_BATCH = 'WITH_BATCH',
  ALL = 'ALL',
  WITHOUT_BATCH = 'WITHOUT_BATCH',
}
export enum PlanningStepEnum {
  ITINERARY = 'ITINERARY',
  ADD_ENTITIES = 'ADD_ENTITIES',
  NEGOTIATIONS_TYPES = 'NEGOTIATIONS_TYPES',
}
export enum TransferUserPermissionEnum {
  NO = 'NO',
  OWNER = 'OWNER',
  ALL = 'ALL',
}
export enum StatusesRelationshipsTypeEnum {
  CHANGE_NEGOTIATIONS = 'CHANGE_NEGOTIATIONS',
  RULE_CHANGES = 'RULE_CHANGES',
  LIMIT_CHANGES = 'LIMIT_CHANGES',
  UNATTACH_NEGOTIATIONS = 'UNATTACH_NEGOTIATIONS',
  CHANGE_NEGOTIATIONS_CONDITIONAL = 'CHANGE_NEGOTIATIONS_CONDITIONAL',
}
export enum ExpirationTypeEnum {
  NO = 'NO',
  ALL = 'ALL',
  WORK_DAYS = 'WORK_DAYS',
  WORK_HOURS = 'WORK_HOURS',
}
export enum RedirectionTypeEnum {
  INTERNAL = 'INTERNAL',
  EXTERNAL_IFRAME = 'EXTERNAL_IFRAME',
  EXTERNAL_NEW_TAB = 'EXTERNAL_NEW_TAB',
  EXTERNAL_SAME_PAGE = 'EXTERNAL_SAME_PAGE',
}
export enum FiltersTypesEnum {
  GROUPS = 'GROUPS',
  USERS = 'USERS',
  NEGOTIATIONS_TYPES = 'NEGOTIATIONS_TYPES',
  NO = 'NO',
}
export enum MembershipStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DELETED = 'DELETED',
  ALL = 'ALL',
  NOMEMBERSHIP = 'NOMEMBERSHIP',
}
export enum ViewersFilterTypeEnum {
  FILTER = 'FILTER',
  GROUP = 'GROUP',
}
export enum ShowGroupsEnum {
  EXTERNAL_CARD = 'EXTERNAL_CARD',
  INTERNAL_REPORT = 'INTERNAL_REPORT',
}
export enum ExportItemsTypeEnum {
  ADDITIONALS_INFORMATIONS = 'ADDITIONALS_INFORMATIONS',
  FIELDS = 'FIELDS',
  DYNAMICS = 'DYNAMICS',
  TITLE = 'TITLE',
}
export enum DaysOfWeekEnum {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}
export enum FilterUserEnum {
  ALL = 'ALL',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}
export enum EditableManagementEnum {
  NEGOTIATIONS = 'NEGOTIATIONS',
  INTERACTIONS = 'INTERACTIONS',
  ENTITIES = 'ENTITIES',
}
export enum NegotiationTransferUserEnum {
  OWNER = 'OWNER',
  ATTENDANT = 'ATTENDANT',
  NO = 'NO',
}
export enum NegotiationTransferUserModeEnum {
  MANUAL = 'MANUAL',
  AUTOMATIC = 'AUTOMATIC',
  NO = 'NO',
}

export enum StatusSearchMambershipEnum {
  ALL = 'ALL',
  MEMBERSHIP = 'MEMBERSHIP',
  DEPENDENT = 'DEPENDENT',
}
export enum SecurityTypeEnum {
  ENCRYT = 'ENCRYT',
  MASK = 'MASK',
  OBFUSCATE = 'OBFUSCATE',
  NO = 'NO',
}
export enum BackupEnum {
  OWN = 'OWN',
  MY_BACKUP = 'MY_BACKUP',
  ALL = 'ALL',
}
export enum JobsActionFrecuencyEnum {
  NOW = 'NOW',
  HOURLY = 'HOURLY',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
}
export enum JobsActionStatusEnum {
  PENDING = 'PENDING',
  DONE = 'DONE',
  ERROR = 'ERROR',
}
export enum JobsActionTargetEnum {
  NEGOTIATIONS = 'NEGOTIATIONS',
  PROCESSES = 'PROCESSES',
}
export enum JobsActionsStepEnum {
  TRANSFER_ADDITIONAL_INFORMATION_NEGOTIATION_TO_SFTP = 'TRANSFER_ADDITIONAL_INFORMATION_NEGOTIATION_TO_SFTP',
  CHANGE_NEGOTIATION_STATUS = 'CHANGE_NEGOTIATION_STATUS',
  SEND_MAIL = 'SEND_MAIL',
  SEND_EXTERNAL_MAIL = 'SEND_EXTERNAL_MAIL',
  SEND_WHATSAPP = 'SEND_WHATSAPP',
  READ_FILE_FROM_SFTP = 'READ_FILE_FROM_SFTP',
  CHANGE_PROCESSES_STATUS = 'CHANGE_PROCESSES_STATUS',
  BATCH_IMPORT = 'BATCH_IMPORT',
  BATCH_EXECUTE = 'BATCH_EXECUTE',
  REASSIGN_DATE = 'REASSIGN_DATE',
  VALIDATE_FINISHED_NEGOTIATIONS = 'VALIDATE_FINISHED_NEGOTIATIONS',
}
export enum GoalFrecuencyEnum {
  DAILY = 'DAILY',
  YEARLY = 'YEARLY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
}
export enum ExternalDataOrder {
  FIRST = 'FIRST',
  LAST = 'LAST',
}
export enum ShowNegotiationsEnum {
  SHOW = 'SHOW',
  HIDE = 'HIDE',
}
export enum TypeActionEnum {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  SHOW = 'SHOW',
}
export enum AccompanimentTypeEnum {
  DEFAULT = 'DEFAULT',
  TEAM_FUNCTION = 'TEAM_FUNCTION',
  SPECIFIC_USERS = 'SPECIFIC_USERS',
  RULES = 'RULES',
  GROUPS = 'GROUPS',
  GROUPS_CATEGORIES = 'GROUPS_CATEGORIES',
  USERS_RELATIONSHIPS = 'USERS_RELATIONSHIPS',
  ALL = 'ALL',
}
export enum GenderUserEnum {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER',
}
export enum ShowChartType {
  COUNT = 'COUNT',
  AMOUNT = 'AMOUNT',
}
export enum DashboardTypeEnum {
  TABLE = 'TABLE',
  GRAPHICS = 'GRAPHICS',
}
export enum PaymentStatusEnum {
  PENDING = 'PENDING',
  PAID = 'PAID',
  PROCESS = 'PROCESS',
  CANCELED = 'CANCELED',
  ALL = 'ALL',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  CANCELLED = 'CANCELLED',
  REFUNDED = 'REFUNDED',
  EXPIRED = 'EXPIRED',
  PROCESSING = 'PROCESSING',
  PARTIAL_REFUND = 'PARTIAL_REFUND',
  CHARGEBACK = 'CHARGEBACK',
}

export enum ViewerKpiVisibleEnum {
  TABLE = 'TABLE',
  GRAPHIC = 'GRAPHIC',
}
export enum ProcessStatusEnum {
  CREATED = 'CREATED',
  SCHUDELED = 'SCHUDELED',
  PROCESING = 'PROCESING',
  ERROR = 'ERROR',
  SEND = 'SEND',
}
export enum StepsMailSenderEnum {
  CLIENT = 'CLIENT',
  OWNER = 'OWNER',
  ATTENDANT = 'ATTENDANT',
}

export enum EmailingTypesEnum {
  INDIVIDUAL = 'INDIVIDUAL',
  MASSIVE = 'MASSIVE',
}
export enum TaskDoneEnum {
  YES = 'YES',
  NO = 'NO',
  ALL = 'ALL',
}
export enum TaskOwnerOptionEnum {
  OWN = 'OWN',
  OTHER = 'OTHER',
  ALL = 'ALL',
}
export enum CentrohubBaseTypeEnum {
  COLEGIOS = 'COLEGIOS',
  UNIVERSIDADES = 'UNIVERSIDADES',
  CLUBES = 'CLUBES',
  CONDOMINIOS = 'CONDOMINIOS',
  COMERCIALES = 'COMERCIALES',
  NINJA = 'NINJA',
}
